import {serviceConnection} from './serviceConnection';
import {serviceConnectionCMS} from './serviceConnectionCMS';
import {servicePossibility} from './servicePossibility';
import {servicePaymentmethods} from './servicePaymentmethods';
import {serviceOnlinecheckout} from './serviceOnlinecheckout';
import {serviceInfrastructure} from './serviceInfrastructure';
import {serviceDocuments} from './serviceDocuments';
import {servicePayouts} from './servicePayouts';

export const service = [
	...serviceConnection,
	...serviceConnectionCMS,
	...servicePossibility,
	...servicePaymentmethods,
	...serviceOnlinecheckout,
	...serviceInfrastructure,
	...serviceDocuments,
	...servicePayouts,
];
